module.exports = __webpack_public_path__ + "img/lock-yellow.03cfe713.svg";